import { type ReactElement, useMemo } from 'react';
import { config } from '@/config';
import { Text } from '@/ui/primitives';
import { formatDate } from '../formatters/formatDate';

type LastRefreshedProps = { timestamp: number | null; label?: string };

export const LastUpdated = ({
  timestamp,
  label = 'Last updated',
}: LastRefreshedProps): ReactElement => {
  const text = useMemo(() => {
    if (!timestamp) {
      return `${label}: n/a`;
    }
    if (config.shouldMaskSnapshots) {
      return `${label}: --`;
    }
    const formatted = formatDate(new Date(timestamp), { includeTime: true });
    return `${label}: ${formatted}`;
  }, [label, timestamp]);

  return (
    <Text role="caption" color="textSecondary">
      {text}
    </Text>
  );
};
